import React from 'react'
import VideoPlayer2 from '../video2/VideoPlayer2'

function Kod20() {
  return (
    <VideoPlayer2 src={'https://app.videas.fr/embed/media/184a5f9d-72f5-4ab9-8041-813464e344ef/'} />
  )
}

export default Kod20